<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <ngx-spinner class="custom-spinner"
  bdColor="rgba(255,255,255,1)"
    size="medium"
    color="#fff"
    type="ball-atom"
    [fullScreen]="true"
  >
  <span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
  </span>
  </ngx-spinner>
    <!--begin::Toolbar container-->
    <div
      id="kt_app_toolbar_container"
      class="app-container container-fluid d-flex flex-stack"
    >
      <!--begin::Page title-->
      <div
        class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
      >
        <!--begin::Title-->
        <div class="d-flex align-items-center">
          <h1 class="page-heading">
            <svg
              width="36"
              height="38"
              viewBox="0 0 36 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_373_934)">
                <path
                  d="M4.60489 6.04201H8.77521C9.1081 6.04201 9.38048 5.76959 9.38048 5.43673V1.26638C9.38048 1.02433 9.23522 0.800305 9.00522 0.709573C8.78127 0.612708 8.521 0.667162 8.34549 0.836657L4.18119 5.00701C4.00564 5.18249 3.95118 5.44279 4.04801 5.66674C4.13882 5.89675 4.36276 6.04201 4.60489 6.04201Z"
                  fill="#265D91"
                />
                <path
                  d="M12.2618 21.9129V18.9894C12.2618 17.9881 13.0763 17.1736 14.0776 17.1736H14.8236L14.2934 16.6434C13.9505 16.3017 13.7614 15.846 13.7614 15.3607C13.7614 14.8754 13.9505 14.4197 14.2946 14.0769L16.3634 12.008C16.6719 11.68 17.1472 11.4778 17.6431 11.4778C18.1301 11.4778 18.587 11.6664 18.9287 12.008L19.4589 12.5383V11.7923C19.4589 10.791 20.2734 9.97647 21.2747 9.97647H23.3385V1.26677C23.3385 0.933843 23.0722 0.661499 22.7332 0.661499H10.486C10.5522 0.851977 10.5914 1.05502 10.5914 1.26677V5.43691C10.5914 6.43821 9.77686 7.25273 8.77556 7.25273H4.60542C4.39378 7.25273 4.19081 7.21343 4 7.14648V25.6473C4 25.9802 4.27234 26.2526 4.60528 26.2526H13.9076C13.8127 26.0304 13.7614 25.7902 13.7614 25.5416C13.7614 25.0563 13.9505 24.6006 14.2946 24.2578L14.823 23.7287H14.0776C13.0763 23.7287 12.2618 22.9142 12.2618 21.9129ZM10.6599 21.5943H7.63357C7.29902 21.5943 7.0283 21.3236 7.0283 20.989C7.0283 20.6545 7.29902 20.3838 7.63357 20.3838H10.6599C10.9945 20.3838 11.2652 20.6545 11.2652 20.989C11.2652 21.3236 10.9945 21.5943 10.6599 21.5943ZM10.6599 17.9627H7.63357C7.29902 17.9627 7.0283 17.692 7.0283 17.3574C7.0283 17.0228 7.29902 16.7521 7.63357 16.7521H10.6599C10.9945 16.7521 11.2652 17.0228 11.2652 17.3574C11.2652 17.692 10.9945 17.9627 10.6599 17.9627ZM10.6599 14.331H7.63357C7.29902 14.331 7.0283 14.0603 7.0283 13.7257C7.0283 13.3912 7.29902 13.1205 7.63357 13.1205H10.6599C10.9945 13.1205 11.2652 13.3912 11.2652 13.7257C11.2652 14.0603 10.9945 14.331 10.6599 14.331ZM10.6599 10.6994H7.63357C7.29902 10.6994 7.0283 10.4287 7.0283 10.0941C7.0283 9.75954 7.29902 9.48882 7.63357 9.48882H10.6599C10.9945 9.48882 11.2652 9.75954 11.2652 10.0941C11.2652 10.4287 10.9945 10.6994 10.6599 10.6994Z"
                  fill="#265D91"
                />
                <path
                  d="M31.3948 18.384H29.0706C28.9617 18.0572 28.8285 17.7364 28.6772 17.4337L30.3175 15.7874C30.5596 15.5514 30.5596 15.17 30.3175 14.934L28.2535 12.8639C28.0174 12.6279 27.6361 12.6279 27.4 12.8639L25.7537 14.5103C25.445 14.3529 25.1303 14.2258 24.8034 14.1168V11.7926C24.8034 11.4537 24.531 11.1873 24.1982 11.1873H21.2747C20.9418 11.1873 20.6694 11.4537 20.6694 11.7926V14.1168C20.3426 14.2258 20.0278 14.3529 19.7191 14.5103L18.0728 12.8639C17.9578 12.7489 17.8064 12.6884 17.643 12.6884C17.4856 12.6884 17.3283 12.7489 17.2193 12.8639L15.1493 14.934C14.9132 15.17 14.9132 15.5514 15.1493 15.7874L16.7956 17.4337C16.6382 17.7364 16.5111 18.0572 16.4022 18.384H14.0779C13.739 18.384 13.4727 18.6564 13.4727 18.9893V21.9128C13.4727 22.2457 13.739 22.5181 14.0779 22.5181H16.4022C16.5111 22.8449 16.6382 23.1597 16.7956 23.4684L15.1493 25.1147C14.9132 25.3508 14.9132 25.7321 15.1493 25.9682L17.2193 28.0321C17.4554 28.2742 17.8367 28.2742 18.0728 28.0321L19.7191 26.3918C20.0278 26.5431 20.3426 26.6763 20.6694 26.7853V29.1095C20.6694 29.4424 20.9418 29.7148 21.2747 29.7148H24.1982C24.531 29.7148 24.8034 29.4424 24.8034 29.1095V26.7853C25.1303 26.6763 25.445 26.5431 25.7537 26.3918L27.4 28.0382C27.509 28.1471 27.6664 28.2137 27.8237 28.2137C27.9871 28.2137 28.1385 28.1471 28.2535 28.0382L30.3175 25.9682C30.5596 25.7321 30.5596 25.3508 30.3175 25.1147L28.6772 23.4684C28.8285 23.1597 28.9617 22.8449 29.0706 22.5181H31.3948C31.7278 22.5181 32.0001 22.2457 32.0001 21.9128V18.9893C32.0001 18.6564 31.7278 18.384 31.3948 18.384ZM22.7334 24.3097C20.6088 24.3097 18.8778 22.5786 18.8778 20.448C18.8778 18.3235 20.6088 16.5925 22.7334 16.5925C24.8639 16.5925 26.595 18.3235 26.595 20.448C26.595 22.5786 24.8639 24.3097 22.7334 24.3097Z"
                  fill="#265D91"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_373_934"
                  x="0"
                  y="0.661499"
                  width="36"
                  height="37.0533"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_373_934"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_373_934"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
  
            CV {{ selectedCandidate?.first_name }}
            {{ selectedCandidate?.last_name }}
          </h1>
  
          <!--begin::Menu-->
        </div>
        <!--end::Title-->
        <!--begin::Breadcrumb-->
        <ul
          class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
        >
          <!--begin::Item-->
          <li class="breadcrumb-item text-muted">
            <a class="text-muted" routerLink="/">Accueil</a>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <li class="breadcrumb-item">
            <span class="bullet bg-gray-400 w-5px h-2px"></span>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <li class="breadcrumb-item text-muted">
            <a class="text-muted" routerLink="/candidats/list-candidats"
              >Liste des candidats</a
            >
          </li>
          <li class="breadcrumb-item">
            <span class="bullet bg-gray-400 w-5px h-2px"></span>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <li class="breadcrumb-item text-muted">Cv candidat</li>
          <!--end::Item-->
        </ul>
        <!--end::Breadcrumb-->
      </div>
      <!--end::Page title-->
      <!--begin::Actions-->
  
      <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
  </div>
<div class="download">
  <div class="actions-profil">

    <button
      class="telecherger"
      type="button"
      id="dropdownMenuButton"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.70019 11.2752C7.13239 11.6339 7.56459 11.4187 7.70866 11.2752L12.0306 6.9709C12.3188 6.68394 12.3188 6.25351 12.0306 5.96655C11.7425 5.6796 11.3103 5.6796 11.0222 5.96655L7.92476 9.05133V0.729598C7.92476 0.299163 7.63663 0.012207 7.20443 0.012207C6.77223 0.012207 6.4841 0.299163 6.4841 0.729598V9.05133L3.38667 5.96655C3.09854 5.6796 2.66634 5.6796 2.37821 5.96655C2.09008 6.25351 2.09008 6.68394 2.37821 6.9709L6.70019 11.2752Z"
          fill="white"
        />
        <path
          d="M13.6863 11.4905C13.2541 11.4905 12.966 11.7774 12.966 12.2079V12.9253H1.44066V12.2079C1.44066 11.7774 1.15253 11.4905 0.720331 11.4905C0.288132 11.4905 0 11.7774 0 12.2079V13.6427C0 14.0731 0.288132 14.36 0.720331 14.36H13.6863C14.1185 14.36 14.4066 14.0731 14.4066 13.6427V12.2079C14.4066 11.7774 14.1185 11.4905 13.6863 11.4905Z"
          fill="white"
        />
      </svg>

      Télécharger
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item" (click)="downloadCV(cvType, 1)">PDF</a>
      <a class="dropdown-item" (click)="downloadCV(cvType, 2)">PDF Anonyme</a>
      <!-- <a class="dropdown-item" (click)="exportCvWordWegest()">Word</a> -->
      <!-- <a class="dropdown-item" (click)="exportCvAnonymeWord()">Word Anonyme</a> -->
    </div>
</div>
</div>

  <div id="kt_app_content" class="app-content flex-column-fluid pt-10">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
      <!--begin::Layout-->
      <body>
        <!--begin::Layout-->
        <div class="content-wrapper overflow-hidden">
          <div class="header" style="padding-bottom:15px">
                <div class="logo-wegestu">
                  <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="" width="90px">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo" alt="" width="90px">
                    <!-- <img class="logo-img" *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="logo" alt="" width="90px"> -->
                </div>
                <section class="main-section pt-6 ralative">
                  <div class="row">
                    <div class="col-xl-4 col-lg-12">
                      <div class="photo-profil">
                        <img *ngIf="selectedCandidate?.image_url && selectedCandidate?.image_url !== 'avatar.png' && selectedCandidate?.image_url !== 'undefined'"
                        [src]="url + '/api/User/file/gallery_users/' + selectedCandidate.image_url"
                        alt="">
                  
                      <img *ngIf="!selectedCandidate?.image_url||selectedCandidate?.image_url&&(selectedCandidate?.image_url=='avatar.png'||selectedCandidate?.image_url=='undefined')"
                          class="table-img" src="/assets/media/avatar.png" alt="" width="75px">
                      </div>
                    </div>
                    <div class="col-xl-8 col-lg-12">
                      <div class="infos details-user" style="margin-left: 25px;">
                        <div class="name-candidat">
                            <h1>{{selectedCandidate?.first_name}} {{selectedCandidate?.last_name}}</h1>
                          </div>
                          <div class="poste" *ngIf="selectedCandidate?.desired_workstation?.length">
                            <p> {{selectedCandidate?.desired_workstation  && selectedCandidate?.desired_workstation!='null' ?  selectedCandidate.desired_workstation:'---'}}</p>
                          </div>
                          <div class="contact" style="display: inline;margin: 0;padding: 0;">
                            <ul >
                              <li *ngIf="selectedCandidate?.email" style="display: inline-block;">
                                <div class="email" style="margin-right:15px">
                                  <img src="/assets/media/icons/env.png" alt="" style="margin-right:5px;">
                                <span> {{selectedCandidate?.email?selectedCandidate.email:'---'}}</span>
                                </div>
                              </li>
                              <li style="display: inline-block;" *ngIf="selectedCandidate?.phone_number">
                                <div class="tel">
                                    <img src="/assets/media/icons/tel.png" alt="">
                                <span>{{selectedCandidate?.phone_number  ? selectedCandidate?.phone_number:'---'}} </span>
                                </div>
                              </li>
    
                            </ul>
                          </div>
                          <div class="plus">
                            <ul>
    
                                  <li *ngIf="selectedCandidate?.linkedin_link?.length">
                                    <div class="linkedin">
                                        <img src="/assets/media/icons/in.png" alt="" style="margin-right: 10px;">
    
                                    <a href="{{selectedCandidate?.linkedin_link}}" target="_blank"> <span>{{selectedCandidate?.linkedin_link?selectedCandidate.linkedin_link:'---'}}</span></a>
                                    </div>
                                  </li>
                                  <li *ngIf="selectedCandidate?.mobility?.length">
                                    <div class="mobilite">
                                        <img src="/assets/media/icons/mob.png" alt="" style="margin-right: 5px;"s>
                                        <ng-container *ngFor="let item of selectedCandidate?.mobility; let last = last">
                                            <span class="mobilite">{{ item }}</span>
                                            <span *ngIf="!last">, </span>
                                        </ng-container>
                                    </div>
                                  </li>
                            </ul>
                          </div>
                      </div>
                    </div>
                  </div>
                </section>
            </div>
            <section class="relative" *ngIf="selectedCandidate?.savoir_faire?.length">
              <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-right">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo" alt="logo" class="logo-right">
              <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-right">
                  <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
                  src="{{baseUrl_Company + selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-right"> -->
              <div class="d-flex align-items-center gap-3 pb-2 px-2" style="border-bottom: 3px double #265d91;">
                <span><img [src]="aboutImage" alt="about" width="20" height="20"></span>
                <span class="section-title">A propos</span>
              </div>
     
              <span class="p-5 m-0"  style="line-height: 27px;" [innerHTML]="selectedCandidate?.savoir_faire | safeHtml"></span>
               <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-center">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo"  alt="logo" class="logo-center">
             
              <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-center">
              <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
           src="{{baseUrl_Company + selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-center"> -->
          </section>
        <section class="skills-section relative" *ngIf="skillsCandidat?.length">
          <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-left">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo" alt="logo" class="logo-left">

          <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-left">
          <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
          src="{{baseUrl_Company + selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-left"> -->
          <div *ngIf="skillsCandidat?.length" class="d-flex align-items-center gap-3 px-2 pb-2" style="border-bottom: 3px double #265d91;">
              <span class="img-icon ">
                <img [src]="skillsImage" alt="skills" width="23" height="23">
              </span>
              <span class="section-title">COMPÉTENCES</span>
          </div>
          <div class="skills-content p-5 pb-2">
                  <div class="row">
                      <div *ngFor="let skill of skillsCandidat" [ngClass]="{'col-xxl-4 col-xl-6 col-sm-12 mb-3':skill.sub_category.length<3, 'col-12 col-sm-12 mb-3':skill.sub_category?.length>3 }">
                              <div class="name-skills">{{skill?.name_FR}}</div>
                            
                              <div class="row">
                                  <div *ngFor="let subSkill of skill.sub_category" [ngClass]="{'col-xxl-4 col-xl-6 col-sm-12':skill.sub_category.length>2, 'col-lg-12':skill.sub_category?.length<2}">
                                      <div>
                                          <div class="d-flex px-5 py-1 gap-7" >
                                              <div class="sub-name-skills">
                                                  <span>{{subSkill?.name_FR}}</span>
                                              </div>
                                              <div class="rating">
                                                  <div class="stars">
                                                      <rating [titles]="[' ',' ',' ',' ',' ']" [(ngModel)]="subSkill.skills[0].stars" [readonly]="true"
                                                          class="rating-stars"></rating>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>  
                      </div>    
                  </div>
                      <div class="other-skills font-bold" *ngIf="selectedCandidate?.skills_text?.length">
                          <span>Autres Compétences : <span class="blue-color font-bold">{{selectedCandidate?.skills_text}}</span> </span>
                      </div>
          </div>
                <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-center">
                <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo"  alt="logo" class="logo-center">

          <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-center">
          <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
          src="{{baseUrl_Company + selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-center"> -->
      </section>
            <section class="Professional-experiences relative" *ngIf="selectedCandidate?.prof_experience?.length">
              <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-left">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo"  alt="logo" class="logo-left">

              <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-left">
              <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
              src="{{baseUrl_Company + selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-left"> -->
              <div *ngIf="selectedCandidate?.prof_experience?.length" class="d-flex align-items-center gap-3 px-2 pb-2" style="border-bottom: 3px double #265d91;">
                  <span class="img-icon img-icon-skills">
                      <img [src]="experienceImage" alt="about" width="23" height="23">
                  </span>
                  <span class="section-title">expériences professionnelles</span>
              </div>
              <div class="experiences-content p-5 pb-2">
                  <div  *ngFor="let item of selectedCandidate?.prof_experience">
                      <div class="name-position">{{capitalizeFirstLetter(item?.poste)}}</div>
                      <table class="m-4 mb-0">  
                          <tbody>
                              <tr class="experience-content" *ngIf="item?.start_date">
                                  <td class="experience-title pb-3 text-left"><span class="attribut">Période</span></td>
                                  <td class="experience-details pb-3 text-left">
                                      <span class="unset-text-transform">
                                        Du {{item?.start_date | date:'MM/yyyy'}}
                                          <span *ngIf="item.current_position =='0'"> Au {{ item?.end_date | date : "MM/yyyy" }}</span>
                                      </span>
                                      <span class="unset-text-transform" *ngIf="item.current_position =='1'">
                                        Jusqu'à présent
                                      </span>
                                      <!-- <span> ({{item.period}})</span> -->
                                  </td>
                              </tr>

                              <tr class="experience-content" *ngIf="item?.client">
                                  <td class="experience-title pb-3 text-left"><span class="attribut">Client</span></td>
                                  <td class="experience-details pb-3 text-left"><span >{{removeHtmlTags(item?.client)}}</span></td>
                              </tr>

                              <tr class="experience-content" *ngIf="item?.project">
                                  <td class="experience-title pb-3 text-left"><span class="attribut">Projet</span></td>
                                  <td class="experience-details pb-3 text-left"><span>{{removeHtmlTags(item?.project ? item?.project:'---' )}}</span></td>
                              </tr>
                              <tr class="experience-content" *ngIf="item?.description">
                                  <td class="experience-title pb-3 text-left"><span class="attribut">Description</span></td>
                                  <td class="experience-details pb-3 text-left" > <span [innerHTML]="item?.description | safeHtml"></span></td>
                              </tr>
                              <tr class="experience-content" *ngIf="item?.method">
                                  <td class="experience-title pb-3 text-left"><span class="attribut">Méthode</span></td>
                                  <td class="experience-details pb-3 text-left"><span>{{removeHtmlTags(item?.method)}}</span></td>
                              </tr>
                              <tr class="experience-content" *ngIf="item?.tasks">
                                  <td class="experience-title pb-3 text-left"><span class="attribut">Tâches</span></td>
                                  <td class="experience-details pb-3 text-left">
                                      <span [innerHTML]="item?.tasks | safeHtml"></span>
                                  </td>
                              </tr>
                              <tr class="experience-content" *ngIf="item?.technologies?.length">
                                  <td class="experience-title pb-3 text-left"><span class="attribut">Outils & technologies</span></td>
                                  <td class="experience-details pb-3 text-left">
                                      <span>{{item?.technologies[0]}}</span>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
              <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-right">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo"  alt="logo" class="logo-right">

              <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-right">
              <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
              src="{{baseUrl_Company + selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-right"> -->
          </section>
          <section class="certif-section relative">
            <div *ngIf="selectedCandidate?.certificat?.length" class="d-flex align-items-center gap-3 px-2 pb-2" style="border-bottom: 3px double #265d91;">
                <span class="img-icon ">
                  <img [src]="certificateImage" alt="certification" width="23" height="23">
                </span>
                <span class="section-title">CERTIFICATIONS</span>
            </div>
           
            <div class="skills-content p-5 pb-2">
                <div class="row" >
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let item of selectedCandidate?.certificat">
                        <div class="d-flex gap-5">
                            <span class="blue-color" *ngIf="item?.date !=='null'">{{item?.date | date:'yyyy'}}</span>
                            <span class="blue-color" *ngIf="item?.date ==='null' || item?.date ==null">N/A</span>
                            <span>
                                {{item?.name}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-center">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo"  alt="logo" class="logo-center">

            <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-center">
            <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
            src="{{baseUrl_Company + selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-center"> -->
          </section>
          <section class="certif-section relative" *ngIf="selectedCandidate?.diplome?.length">

            <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-left">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo"  alt="logo" class="logo-left">

            <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-left">
            <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
            src="{{baseUrl_Company + selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-left"> -->
            <div class="d-flex align-items-center gap-3 px-2 pb-2" style="border-bottom: 3px double #265d91;">
                <span class="img-icon ">
                  <img [src]="graduationImage" alt="graduation" width="23" height="23">
                </span>
                <span class="section-title">DIPLÔMES</span>
            </div>
           
            <div class="diplome-content p-5 pb-2">
                <div class="row" >
                    <div class="content-diplome" *ngFor="let item of selectedCandidate?.diplome">
                        <div class="d-flex gap-5">
                            <span class="blue-color" *ngIf="item?.date !=='null'">{{item?.date | date:'yyyy'}}</span>
                            <span class="blue-color" *ngIf="item?.date ==='null' || item?.date ==null">N/A</span>
                            <span>
                                {{item?.name}}
                            </span>
                        </div>
                        <div class="name-ecole">{{item?.ecole}}</div>
                    </div>
                </div>
            </div>
           <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-right">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo"  alt="logo" class="logo-right">

            <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-right">
            <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
            src="{{baseUrl_Company + selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-right"> -->
          </section>
            <section *ngIf="selectedCandidate?.softSkills?.length>0" class="softskills-section">
              <div class="d-flex align-items-center gap-3 px-2 pb-2" style="border-bottom: 3px double #265d91;">
                  <span class="img-icon ">
                    <img [src]="softSkillsImage" alt="skills" width="23" height="23">
                  </span>
                  <span class="section-title">Soft Skills</span>
              </div>
             
              <div class="skills-content p-5">
                  <div class="row" >
                      <div class="col-lg-4 col-md-6 col-sm-12"  *ngFor="let item of selectedCandidate?.softSkills">
                          <div class="pb-2" *ngIf="item">{{ item }}</div>
                      </div>
                  </div>
              </div>
          </section>

          <section *ngIf="selectedCandidate?.langue_user?.length" class="langue-section relative">
              <div class="d-flex align-items-center gap-3 px-2 pb-2" style="border-bottom: 3px double #265d91;">
                  <span class="img-icon ">
                    <img [src]="languageImage" alt="certification" width="23" height="23">
                  </span>
                  <span class="section-title">Langues</span>
              </div>
             
              <div class="langue-content p-5 pb-2">
                  <div class="row" >
                      <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let item of selectedCandidate?.langue_user">
                          <div class="d-flex gap-5">
                              <div >{{item?.name}}</div>
                              <div class="value">
                                  <div class="stars">
                                      <rating [titles]="[' ',' ',' ',' ',' ']" [(ngModel)]="item.stars" [readonly]="true"
                                          class="rating-stars"></rating>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <img class="logo-img" *ngIf="typeCv=='WEGESTU'" [src]="imageLogo" alt="logo" class="logo-center">
                  <img class="logo-img" *ngIf="typeCv=='ESN'" [src]="logo"  alt="logo" class="logo-center">
              <!-- <img *ngIf="!selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo" [src]="imageLogo" alt="logo" class="logo-center">
              <img *ngIf="selectedCandidate?.consultant_e_s_n[0]?.e_s_n?.logo"
              src="{{baseUrl_Company + selectedCandidate?.langue_user?.length?.consultant_e_s_n[0]?.e_s_n?.logo }}" alt="logo" class="logo-center"> -->
          </section>
        </div>
    </body>
      <!--end::Content container-->
    </div>
  </div>
  